import ApiGateway from '../api-gateway/api-gateway';
import UserSession from '@app/common/user-session';
import axios from 'axios';
import { tokenIsValid } from '@app/lib/utils';
import { cognitoUser } from '@app/lib/cognito';
import { store } from '@app/store';

export default {
  async getAll(allLevels) {
    const state = store.getState();
    const expiration = state.common.auth.session?.expiration ?? 0;

    if (tokenIsValid(expiration)) {
      const path = allLevels ? '/partners?level=all' : '/partners';
      const result = await ApiGateway.get(path);
      return result.data.partners;
    }
    else {
      cognitoUser.signOut();
      return false;
    }
  },

  async get(id) {
    const state = store.getState();
    const expiration = state.common.auth.session?.expiration ?? 0;

    if (tokenIsValid(expiration)) {
      const result = await ApiGateway.get(`/partners/${id}`);
      return result.data.partner;
    }
    else {
      cognitoUser.signOut();
      return false;
    }
  },

  async create(payload) {
    const state = store.getState();
    const expiration = state.common.auth.session?.expiration ?? 0;

    if (tokenIsValid(expiration)) {
      const result = await ApiGateway.post('/partners', payload);
      return result.data?.partner ?? null;
    }
    else {
      cognitoUser.signOut();
      return false;
    }
  },

  async update(id, payload) {
    const state = store.getState();
    const expiration = state.common.auth.session?.expiration ?? 0;

    if (tokenIsValid(expiration)) {
      const result = await ApiGateway.patch(`/partners/${id}`, payload);
      return result.data.partner;
    }
    else {
      cognitoUser.signOut();
      return false;
    }
  },

  async getSites(id) {
    const state = store.getState();
    const expiration = state.common.auth.session?.expiration ?? 0;

    if (tokenIsValid(expiration)) {
      const result = await ApiGateway.get(`/partners/${id}/sites`);
      return result.data.sites;
    }
    else {
      cognitoUser.signOut();
      return false;
    }
  },

  async getControllers(id) {
    const state = store.getState();
    const expiration = state.common.auth.session?.expiration ?? 0;

    if (tokenIsValid(expiration)) {
      const result = await ApiGateway.get(`/partners/${id}/controllers`);
      return result.data.controllers;
    }
    else {
      cognitoUser.signOut();
      return false;
    }
  },

  async getAssumedRole(id) {
    const state = store.getState();
    const expiration = state.common.auth.session?.expiration ?? 0;

    if (tokenIsValid(expiration)) {
      const result = await ApiGateway.get(`/partners/${id}/assumed-role`);
      return result.data;
    }
    else {
      cognitoUser.signOut();
      return false;
    }
  },

  async getPaymentMethods(id) {
    const state = store.getState();
    const expiration = state.common.auth.session?.expiration ?? 0;

    if (tokenIsValid(expiration)) {
      const result = await ApiGateway.get(`/partners/${id}/payment-methods`);
      return result.data.payment_methods;
    }
    else {
      cognitoUser.signOut();
      return false;
    }
  },

  async addPaymentMethod(id, payload) {
    const state = store.getState();
    const expiration = state.common.auth.session?.expiration ?? 0;

    if (tokenIsValid(expiration)) {
      const result = await ApiGateway.post(`/partners/${id}/payment-methods`, payload);
      return result;
    }
    else {
      cognitoUser.signOut();
      return null;
    }
  },

  async updatePaymentMethod(id, payload) {
    const state = store.getState();
    const expiration = state.common.auth.session?.expiration ?? 0;

    if (tokenIsValid(expiration)) {
      const result = await ApiGateway.patch(`/partners/${id}/payment-methods`, payload);
      return result;
    }
    else {
      cognitoUser.signOut();
      return null;
    }
  },

  async getPreferences(id) {
    const result = await ApiGateway.get(`/partners/${id}/preferences`);
    return result.data.preferences;
  },

  // TODO: Refactor these headers etc. into ApiGateway functions
  async updatePreferences(id, payload) {
    const state = store.getState();
    const expiration = state.common.auth.session?.expiration ?? 0;

    if (tokenIsValid(expiration)) {
      let formData = new FormData();
      const fileHeaders = {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${UserSession.getToken()}`,
      }
  
      formData.append('pageTitle', payload.pageTitle || 'Orchestrator');
      if (payload.headerColor) {
        const headerColorValue = payload.headerColor === 'default' ? '#85ba3b' : payload.headerColor;
        formData.append('headerColor', headerColorValue);
      }
  
      if (payload.logo instanceof File) {
        formData.append('logo', payload.logo);
      }
      if (payload.favicon instanceof File) {
        formData.append('favicon', payload.favicon);
      }
  
      const result = await axios.post(
        process.env.REACT_APP_API_URL + `/partners/${id}/preferences`,
        formData, { headers: fileHeaders }
      );
  
      return result.data?.preferences ?? [];
    }
    else {
      cognitoUser.signOut();
      return false;
    }
  }
}
